import { getMessages } from '../../../../../../../store/constants';

export const CARD_ESTIMATE_AND_SPENT_TIME = getMessages().getText('card_form_section_estimate_and_spent_time');
export const CARD_ESTIMATE_LABEL_TEXT = getMessages().getText('card_form_section_estimate_label_text');
export const CARD_SPENT_TIME_LABEL_TEXT = getMessages().getText('card_form_section_spent_time_label_text');
export const CARD_ESTIMATE_EXAMPLE = getMessages().getText('card_form_section_estimate_example');
export const CARD_ESTIMATE_PLACEHOLDER = getMessages().getText('card_form_section_estimate_placeholder');
export const CARD_ESTIMATE_REMOVE_TOOLTIP = getMessages().getText('card_form_section_estimate_remove');
export const CARD_ESTIMATE_SPENT_TOOLTIP = getMessages().getText('card_form_section_estimate_spent');
export const CARD_ESTIMATE_TRACKER_TOOLTIP = getMessages().getText('card_form_section_estimate_tracker');
export const CARD_ESTIMATE_ESTIMATE_TOOLTIP = getMessages().getText('card_form_section_estimate_estimate');
